"use client";

import { rpc } from "@/data/rpc.client";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const useKlaviyoProfile = (email: string | undefined) => {
	const query = useQuery({
		queryKey: ["klaviyo-profile", email],
		queryFn: () => rpc.klaviyo.getProfile(email!),
		enabled: !!email,
		staleTime: 1000 * 60 * 5, // 5 minutes
	});

	return query;
};

export const useKlaviyoBackInStock = () => {
	return useMutation({
		mutationKey: ["klaviyo-back-in-stock"],
		mutationFn: ({
			email,
			externalVariantId,
		}: {
			email: string;
			externalVariantId: string;
		}) => rpc.klaviyo.backInStock(email, externalVariantId),
	});
};

export const useUpdateKlaviyoProfile = () => {
	const queryClient = useQueryClient();

	const updateMutation = useMutation({
		mutationKey: ["klaviyo-profile-update"],
		mutationFn: ({
			company,
			vatNumber,
			email,
		}: {
			company: string;
			vatNumber: string;
			email: string;
		}) => rpc.klaviyo.updateProfile(email!, company, vatNumber),
		onSuccess: (data, variables) => {
			// Immediately update the cache for faster UI response
			queryClient.setQueryData(["klaviyo-profile", variables.email], data);
		},
		onSettled: (data, err, variables) => {
			// Invalidate to ensure fresh data
			queryClient.invalidateQueries({
				queryKey: ["klaviyo-profile", variables.email],
			});
		},
	});

	return updateMutation;
};
